import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../auth';
import { ProfileThemeSettings } from '../components/account/ProfileThemeSettings';
import { VIcon } from '../components/keno/VCredit';
import { Button } from '../components/ui/button';
import { usePlayerProfile } from '../components/account/usePlayerProfile';
import { ProfileDetails } from '../components/account/ProfileDetails';
import '../components/account/settings.css';

export default function Account() {
  const { user, loading } = useAuth();
  const { hash } = useLocation();
  useEffect(() => { if (user && hash) document.getElementById(hash.slice(1))?.scrollIntoView({ block: 'start' }); }, [hash, user]);
  const userId = user?.id;
  const { profile, balances, balanceError, error, refresh } = usePlayerProfile(userId);
  if (loading) return <p className="p-8" data-testid="account-loading">Loading…</p>;
  if (!user) return <Navigate to="/" replace />;
  const total = profile ? BigInt(profile.total_wagered_minor) : 0n;
  const wagered = `${(total / 100n).toLocaleString('en-US')}.${(total % 100n).toString().padStart(2, '0')}`;
  return <div className="my-profile-content" data-testid="my-profile-page">
      {error && <div className="settings-error" role="alert" data-testid="account-stats-error">{error}<Button variant="ghost" data-testid="account-stats-retry" onClick={refresh}><RefreshCw size={15} />Retry</Button></div>}
      {!profile && !error && <p className="settings-hint" data-testid="account-stats-loading">Loading statistics…</p>}
      {profile && <dl className="my-profile-stats"><div><dt>Amount wagered</dt><dd data-testid="account-wagered"><VIcon testid="account-wagered-icon" /><span title={wagered}>{wagered}</span></dd></div>{[['bets_won', 'Bets won', 'wins'], ['bets_lost', 'Bets lost', 'losses'], ['settled_bets', 'Total bets', 'total']].map(([key, label, id]) => <div key={key}><dt>{label}</dt><dd data-testid={`account-stats-${id}`}>{profile[key].toLocaleString('en-US')}</dd></div>)}</dl>}
      {profile && <ProfileDetails profile={profile} balances={balances} balanceError={balanceError} prefix="account" />}
      <ProfileThemeSettings />
  </div>;
}